import { apiAction } from 'base/utils/apiHelpers';

import { CART_ITEMS_AVAILABLE_ENDPOINT } from 'base/constants/endpoints';
import {
  CART_ITEMS_AVAILABLE_REQUEST,
  CART_ITEMS_AVAILABLE_SUCCESS,
  CART_ITEMS_AVAILABLE_FAILURE,
  CART_ITEMS_AVAILABLE_RESET
} from 'cart/constants/actionTypes';

/**
 * Determine if the current cart items are available
 * base on the cart fulfillment date and time
 */
export const getIsCartItemsAvailable = fulfillmentOptions => dispatch => {
  const endpoint = CART_ITEMS_AVAILABLE_ENDPOINT;
  return dispatch(
    apiAction(
      endpoint,
      'PUT',
      [
        CART_ITEMS_AVAILABLE_REQUEST,
        CART_ITEMS_AVAILABLE_SUCCESS,
        CART_ITEMS_AVAILABLE_FAILURE
      ],
      fulfillmentOptions
    )
  );
};

/**
 * Reset the cartAvailable state to true
 */
export const resetIsCartItemAvailable = () => {
  return { type: CART_ITEMS_AVAILABLE_RESET };
};
